import { useFetcher, useLocation } from 'react-router'
import { ServerOnly } from 'remix-utils/server-only'
import { useRequestInfo } from '#app/utils/request-info.ts'

export function BetaBanner() {
	const fetcher = useFetcher()
	const location = useLocation()
	const { userPrefs } = useRequestInfo()

	if (userPrefs.betaBannerDismissed) {
		return null
	}

	return (
		<fetcher.Form
			method="POST"
			action="/resources/dismiss-beta-banner"
			role="alert"
			className="mt-4 flex w-full flex-col items-start space-y-2 bg-yellow-100 p-4 text-yellow-900 shadow-md sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-4"
		>
			<ServerOnly>
				{() => (
					<input
						type="hidden"
						name="redirectTo"
						value={`${location.pathname}${location.search}`}
					/>
				)}
			</ServerOnly>
			<p className="flex-1 text-sm">
				🚀 {import.meta.env.VITE_APP_TITLE} is in early beta! Some features may
				not work perfectly yet. Please report any bugs or ideas using the
				“Report Issue” button at the bottom of any page. 🌎
			</p>
			<button
				type="submit"
				className="rounded-md border border-yellow-400 bg-yellow-200 px-3 py-1 text-sm font-medium hover:bg-yellow-300 focus:ring-2 focus:ring-yellow-500 focus:outline-hidden"
				aria-label="Dismiss beta announcement"
			>
				Dismiss
			</button>
		</fetcher.Form>
	)
}
